import { render } from "./EmisionDetalleCargo.vue?vue&type=template&id=5631c784&scoped=true"
import script from "./EmisionDetalleCargo.vue?vue&type=script&lang=js"
export * from "./EmisionDetalleCargo.vue?vue&type=script&lang=js"

import "./EmisionDetalleCargo.vue?vue&type=style&index=0&id=5631c784&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5631c784"]])

export default __exports__